import { useTenantFeatures } from '@/shared/auth/store'

/**
 * Whether the current tenant is in the automated-investigations beta. Gates
 * every beta-announcement surface (sidebar button, inline glow triggers, and
 * the dialog). The flag is tenant-level, so all users in the tenant see it.
 */
export const useInInvestigationsBeta = (): boolean =>
	Boolean(useTenantFeatures()?.beta_enable_automated_investigations)
